import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type { IApiGetArticleResponseBody } from '../ArticlesApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseArticleQueryValues = {
  appId: string;
  articleId: string;
};

export const articleQueryKeyFactory: IQueryKeyFactory<
  IUseArticleQueryValues
> = (values) =>
  values && (['article', values.appId, values.articleId] as const);

export const useArticleQuery = (
  values?: IUseArticleQueryValues,
  options?: UseQueryOptions<IApiGetArticleResponseBody, ApiError>,
): UseQueryResult<IApiGetArticleResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: articleQueryKeyFactory(values),
    queryFn: values
      ? () => api.articles.get(values.appId, values.articleId)
      : undefined,
    enabled: !!values,
    ...options,
  });
};
